import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserModel } from '@common/models/User.model';
import { currentUserSubject } from '../services/user.service';

@Injectable()
export class UserCreateGuard {
    private currentUser: UserModel;

    constructor(private router: Router) {
        currentUserSubject.subscribe((user) => {
            this.currentUser = user;
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const status = !this.currentUser;

        // only not logged in users can access this route
        if (status) {
            return true;
        } else {
            this.router.navigate(['/']);
        }

        return status;
    }
}
